import { createContext } from 'react';
interface WakeLockContextType {
  request: () => Promise<void>;
  isSupported: boolean;
  released: boolean | undefined;
  release: () => Promise<void>;
}

export const WakeLockContext = createContext<WakeLockContextType | undefined>(undefined);